module.exports = "<div v-bind:class=\"{'Input--filled': !empty || active, 'Input--invalid': error, 'Input--valid': complete }\" :skin=skins.inputs class=Input><div class=\"Input__field Input__field--stripe\"><div :id=type></div></div><label class=Input__label><span class=Input__label-content><span class=Input__icon>{{ type | splitCamelCaseToString }}</span></span></label></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/forms/interrupts/element.vue
// module id = 425
// module chunks = 0